import { render, staticRenderFns } from "./form-buttons.vue?vue&type=template&id=17470ddc&"
import script from "./form-buttons.vue?vue&type=script&lang=js&"
export * from "./form-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports